import { StaticLayout } from './static-layout'

export function FeaturesPage() {
  return (
    <StaticLayout title="Features" description="What you get with mkdn.app.">
      <h2>Writing</h2>
      <ul>
        <li>CodeMirror-based markdown editor with syntax highlighting</li>
        <li>Live preview, edit-only, or split view</li>
        <li>Formatting toolbar for headings, lists, links, images, code blocks, tables</li>
        <li>GitHub-flavoured markdown (tables, task lists, strikethrough)</li>
        <li>Syntax-highlighted fenced code blocks</li>
      </ul>
      <h2>Collaboration</h2>
      <ul>
        <li>Real-time editing with CRDT-based conflict resolution (Yjs)</li>
        <li>Live cursors and per-user colours</li>
        <li>Anonymous viewers welcome — no account required to open a shared link</li>
      </ul>
      <h2>Sharing</h2>
      <ul>
        <li>One-click share link with read-only or read-write access</li>
        <li>Presentation mode for distraction-free viewing</li>
        <li>Private by default — sharing is off until you flip the switch</li>
      </ul>
      <h2>History &amp; export</h2>
      <ul>
        <li>Version history with one-click restore (signed-in users)</li>
        <li>Export to Markdown or HTML</li>
      </ul>
      <h2>Free</h2>
      <p>
        Everything above is free. No paywalled features, no premium tier.
      </p>
    </StaticLayout>
  )
}
